type Langs = {
  [key: string]: {
    nameBase: string;
    nameNative: string;
    nameShort: string;
  };
};

export const langs: Langs = {
  en: { nameBase: 'English', nameNative: 'English', nameShort: 'EN' },
  de: { nameBase: 'German', nameNative: 'Deutsch', nameShort: 'DE' },
  es: { nameBase: 'Spanish', nameNative: 'Español', nameShort: 'ES' },
  fr: { nameBase: 'French', nameNative: 'Français', nameShort: 'FR' },
  it: { nameBase: 'Italian', nameNative: 'Italiano', nameShort: 'IT' },
  ja: { nameBase: 'Japanese', nameNative: '日本語', nameShort: 'JA' },
  nl: { nameBase: 'Dutch', nameNative: 'Nederlands', nameShort: 'NL' },
  pl: { nameBase: 'Polish', nameNative: 'Polski', nameShort: 'PL' },
  pt: { nameBase: 'Portuguese', nameNative: 'Português', nameShort: 'PT' },
  sv: { nameBase: 'Swedish', nameNative: 'Svenska', nameShort: 'SV' },
  // ru: { nameBase: 'Russian', nameNative: 'Русский', nameShort: 'RU' },
  // zh: {
  //   nameBase: 'Chinese (Simplified)',
  //   nameNative: '简体中文',
  //   nameShort: 'ZH',
  // },
};
